import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sub-category',
  templateUrl: './sub-category.component.html',
  styles: [
  ],
})
export class SubCategoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
